"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HousePriceIndexWrapper$ = exports.HousePriceIndexWrapper$outboundSchema = exports.HousePriceIndexWrapper$inboundSchema = void 0;
exports.housePriceIndexWrapperToJSON = housePriceIndexWrapperToJSON;
exports.housePriceIndexWrapperFromJSON = housePriceIndexWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const housepriceindexattributes_js_1 = require("./housepriceindexattributes.js");
/** @internal */
exports.HousePriceIndexWrapper$inboundSchema = z.object({
    attributes: housepriceindexattributes_js_1.HousePriceIndexAttributes$inboundSchema,
    id: z.string(),
    type: z.literal("house_price_index_month").default("house_price_index_month")
        .optional(),
});
/** @internal */
exports.HousePriceIndexWrapper$outboundSchema = z.object({
    attributes: housepriceindexattributes_js_1.HousePriceIndexAttributes$outboundSchema,
    id: z.string(),
    type: z.literal("house_price_index_month").default("house_price_index_month"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var HousePriceIndexWrapper$;
(function (HousePriceIndexWrapper$) {
    /** @deprecated use `HousePriceIndexWrapper$inboundSchema` instead. */
    HousePriceIndexWrapper$.inboundSchema = exports.HousePriceIndexWrapper$inboundSchema;
    /** @deprecated use `HousePriceIndexWrapper$outboundSchema` instead. */
    HousePriceIndexWrapper$.outboundSchema = exports.HousePriceIndexWrapper$outboundSchema;
})(HousePriceIndexWrapper$ || (exports.HousePriceIndexWrapper$ = HousePriceIndexWrapper$ = {}));
function housePriceIndexWrapperToJSON(housePriceIndexWrapper) {
    return JSON.stringify(exports.HousePriceIndexWrapper$outboundSchema.parse(housePriceIndexWrapper));
}
function housePriceIndexWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.HousePriceIndexWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'HousePriceIndexWrapper' from JSON`);
}
//# sourceMappingURL=housepriceindexwrapper.js.map